import { render } from "./forSale.vue?vue&type=template&id=678a55d7"
const script = {}

import exportComponent from "C:\\Users\\Kumas\\merchandise_record\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__